class NavRoutes {
  static PUBLIC = {
    LOGIN: 'login',
    LOGOUT: 'logout',
    VERIFY_OTP: 'verify-otp',
    REGISTER: 'register',
    FORGOT_PASSWORD: 'forgotPassword',
    RESET_PASSWORD: 'resetPassword',
    VERIFY_ACCOUNT: 'verifyAccount',
    '404': '404',
    CREATE_CLINIC_GROUP: 'createClinicGroup',
    PAYMENTS_LOGIN: 'paymentsLogin',
    PAYMENTS_DASHBOARD: 'paymentsDashboard',
    PAYMENTS_DETAILS: 'paymentDetails',
    SEND_EMAIL: 'sendEmail',
    MAIL_CHECK: 'mailCheck',
    THANKS_SCREEN: 'thanksScreen',
    PAYMENTS_SECTION: 'paymentSection',
    CARD_PAYMENT_DASHBOARD: 'cardPayment',
    ERROR_PAY: 'error',
    PAYMENT_REDIRECT: 'pay',
    PATIENT_FORM_REDIRECT: 'form',
    PAYMENT_PRACTICE_REDIRECT: 'practice',
    PAYMENT_PRACTICE: 'pay-practice',
    GUARANTOR_INFO: 'gi',
    PAY: 'pay',
    DETAILS: 'details',
    GUARANTOR_PAYMENT_DETAILS: 'guarantorPaymentDetails',
    VOICE_ASSISTANT: 'assistant',
    ACCEPT_INVITATION: 'acceptInvitation',
    // APPOINTMENT_SCHEDULAR_DASHOBARD: 'appt'
    /** Appointment Portal */
    APPOINTMENT_PORTAL: {
      BASE: 'appt',
      LOGIN: 'login',
      HOME: 'home',
      UPLOAD_INSURANCE: 'upload-insurance',
      SCHEDULE_APPOINTMENT: 'schedule-appointment'
    }
  };

  static PRIVATE = {
    HOME: 'home',
    PROFILE: 'profile',
    PATIENTS: 'patients',
    ADMIN: {
      CLINICS: 'Clinics',
      CLINICS_NESTED: {
        PRACTICES: 'practices',
        USERS: 'users',
        CARD_MACHINES: 'card-machines',
        HEALTHCARE_PROVIDERS: 'healthcare-providers',
        BILLS: 'bills',
        PAYMENTS_HISTORY: 'payments-history',
        CLINIC_GROUP_PAYERS: 'group-payers',
        SCHEDULED_JOBS: 'scheduled-jobs',
        APPOINTMENT_SLOTS: 'appointment-slots',
        HOLIDAYS_LIST: 'holidays-list',
        VACCINES_LIST: 'vaccines-list',
        CLINIC_PROVIDERS: 'providers-list',
        SERVICE_LOCATION: 'service-location',
        EMR_SEARCH_ATTRIBUTES: 'emr-request-logs',
        APPOINTMENT_TYPE: 'appointment-type',
        VOICE_AGENT_CONFIG: 'voice-agent-config',
        EMR_INTEGRATION: 'emr-integration'
      },
      PATIENTS: 'Patients',
      PATIENTS_NEST: {
        APPOINTMENT: 'appointment',
        LIST: 'list'
      },
      APPOINTMENTS: 'Appointments',
      INVOICES: 'Invoices',
      PAYMENTS: 'payments',
      INCOMING_SMS: 'incomingSms',
      INVOICES_NESTED: {
        SEARCH_INVOICES: 'search-invoices',
        DUE_INVOICES: 'dueInvoices',
        SETTLED_INVOICES: 'settledInvoices',
        CHECK_STATUS_INVOICES: 'checkInvoices',
        ALL_INVOICES: 'allInvoices',
        PAYMENT_HISTORY: 'paymentHistory',
        NOTIFICATIONS_HISTORY: 'notificationsHistory',
        ACTION_HISTORY: 'actionHistory',
        VIEW_ACTION_HISTORY: 'Invoices/actionHistory',
        PREVIOUS_IMPORTED_STATEMENTS: 'previousImportedStatements'
      },
      DASHBOARD: 'dashboard',
      USERDASHBOARD: 'userdashboard',
      CLINIC_GROUP: 'clinicGroups',
      ADMIN: 'admins',
      REPORT: 'report',
      VACCINES: 'vaccines',
      CCM: 'ccm',
      CCM_TABS: {
        PATIENTS: 'patients',
        // REPORTS: 'reports',
        BILLING: 'billing',
        DASHBOARD: 'dashboard',
        REPORTS_TABS: {
          BILLING: 'billingmonth'
        }
      },
      PATIENT_RECALL: 'patientrecall',
      PATIENT_RECALL_NESTED: {
        RECALL_ANALYSIS: 'analysis',
        RECALL_REMINDER_HISTORY: 'reminders',
        RECALL_METRICS: 'metrics'
      },
      REPORTS: 'reports',
      GATHERED_FEEDBACK: 'gathered-feedback',
      PRIOR_AUTHORIZATIONS: 'prior-authorizations',
      CLAIMS_TICKETS: 'claims',
      REFERRAL_TICKETS: 'referrals',
      SCHEDULED_JOBS: 'scheduled-jobs',
      HOLIDAYS_LIST: 'holidays-list',
      VACCINES_LIST: 'vaccine-list',
      D0_CONFIGURATION: 'do-configuration-list',
      APPOINTMENT_TYPE: 'appointment-type',
      VOICE_AGENT_CONFIG: 'voice-agent-config',
      EMR_MAPPINGS_FILE: 'emr-mappings-file',
      EMR_SYNC: 'emr-sync',
      EMR_SYNC_NESTED: {
        DASHBOARD: 'dashboard',
        QUEUE: 'queue',
        MATCH_REVIEW: 'match-review',
        CAPABILITY: 'capability'
      },
      EMR_SYNC_PLATFORM: 'emr-sync-platform',
      USERS: 'users',
      PATIENT_FORM: 'patient-form',
      CLAIMS: 'pharmacy-claims',
      CLAIMS_NESTED: {
        DASHBOARD: 'dashboard',
        ACCOUNTS: 'accounts',
        INVOICES: 'invoices',
        CLAIMS: 'claimsAnalysis',
        /** Pharmacy claims blocked until dose/address/etc. are fixed */
        CLAIM_TODOS: 'claim-todos',
        EDI: 'edi',
        REPORTS: 'reports'
      }
    },
    CLINIC_ADMIN: {
      CLINICS: 'clinics',
      USERS: 'users',
      VACCINES: 'vaccines',
      BILLING: 'billing'
    },
    USER: {
      CHANGE_PASSWORD: 'changePassword'
    }
  } as const;
}

export default NavRoutes;
